// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

export { SEED_ORG_PLACEHOLDER, SEED_WORKSPACE_PLACEHOLDER } from './constants'
export type { SeedSchema } from './constants'
import type { SeedSchema } from './constants'

import { orchestrationSeeds } from './orchestration'
import { assignmentSeeds } from './assignments'
import { dashboardSeeds } from './dashboard'
import { gitSeeds } from './git'

/**
 * Core seeds required by the shell infrastructure.
 * These are always seeded regardless of which apps are installed:
 * - orchestration: agent pipeline (proposals, missions, steps, events, triggers, policies, affinities)
 * - assignments: generic entity→team-member linking (category: 'core')
 * - dashboard: dashboard rendering framework (dashboards, templates, components)
 *
 * Domain seeds (crm, sales, finance, etc.) are contributed by their
 * respective app plugins via `contributes.schemas` manifests.
 */
export const coreSeeds: SeedSchema[] = [
  ...orchestrationSeeds,
  ...assignmentSeeds,
  ...dashboardSeeds,
]

export { orchestrationSeeds, assignmentSeeds, dashboardSeeds, gitSeeds }
